module.exports = __webpack_public_path__ + "static/img/keep-on-top-of-changes.ec3bab9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fundamentals/keep-on-top-of-changes.png
// module id = wsO1
// module chunks = 0